import React from 'react';

const SvgRobot = props => (
	<svg width="1em" height="1em" viewBox="0 0 12 12" {...props}>
		<g transform="translate(0 1)">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M6 0a.5.5 0 0 1 .5.5V1h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2V3a2 2 0 0 1 2-2h.5V.5A.5.5 0 0 1 6 0zM5 2a1 1 0 0 0-1 1v1h4V3a1 1 0 0 0-1-1H5zM3 5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3zm1 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm3.5.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0z"
			/>
		</g>
	</svg>
);

export default SvgRobot;
